import React, { Component } from 'react';

import { withApi } from '../Providers/WebServiceProvider.js';
import ResourcesHandlerService from '../Services/ResourcesHandlerService.js';

import { message } from '../messages.js';
import Swal from 'sweetalert2';

class DownloadResourcesButton extends Component
{
	constructor (props) {
		super (props);
   	this.resourcesHandler = new ResourcesHandlerService(props.webServiceContext.getApi());
    this.handleResourcesDownload = this.handleResourcesDownload.bind(this);
	}

  handleResourcesDownload() { 
  	const that = this;

    Swal(message('RESOURCES_DOWNLOADING_SHORT'), message('RESOURCES_DOWNLOADING'), 'info');

    this.resourcesHandler.information().then(function (response) {
	 		let allCompleted = true;
	 		let toTranslate = [];
	 		let toValidate  = [];

	 		response.locales.forEach(function (locale) {
	 			if (!locale.translated || !locale.validated) {
	 				allCompleted = false;

	 				if (!locale.translated) {
	 					toTranslate.push(locale.key);
	 				}

	 				if (!locale.validated) {
	 					toValidate.push(locale.key);
	 				}
	 			}
	 		});

			that.resourcesHandler.download().then(function (response) {
	      const url = window.URL.createObjectURL(new Blob([response.data]));
	      const link = document.createElement('a');
	      link.href = url;
	      link.setAttribute('download', 'tovertaal_assets.tar.gz');
	      document.body.appendChild(link);
	      link.click();

	      if (allCompleted) {
	      	Swal('Downloaded.', message('RESOURCES_DOWNLOADED_SUCCESSFULLY', 'tovertaal_assets.tar.gz'), 'success');
	      } else {
			 		let html = message('RESOURCES_DOWNLOADED_WARNING') + " <br /> <br />";
			 		if (toTranslate.length) {
			 			html += message('RESOURCES_DOWNLOADED_WARNING_MISSING_TRANSLATIONS', toTranslate.join(", ")) + " <br/>"
			 		}
			 		if (toValidate.length) {
			 			html += message('RESOURCES_DOWNLOADED_WARNING_MISSING_VALIDATIONS', toValidate.join(", "))
			 		}

			 		Swal({
						title: "Warning!",
						html: html,
						type: "warning"
			 		});
	      }
	     }).catch(function () {
	      Swal('Oops...', message('RESOURCES_NO_AVAILABILITY'), 'error');
	    });
    });
  }

	render () {
		return (
      <button onClick={this.handleResourcesDownload} className="button is-primary is-outlined">
        Download Localisations
      </button>
		);
	}
}

export default withApi(DownloadResourcesButton);


// WEBPACK FOOTER //
// ./src/Components/DownloadResourcesButton.js